const ContactProfileView = {
    CONTACT_OVERVIEW: "CONTACT_OVERVIEW",
    CONTACT_EMPLOYEE_OVERVIEW: "CONTACT_EMPLOYEE_OVERVIEW",
    CONTACT_VEHICLES_OVERVIEW: "CONTACT_VEHICLES_OVERVIEW"
};

export default ContactProfileView;
